// Country list with flag emojis for Booking Form country selector.
// Sorted with common DACH countries at top, then alphabetical.

export const COUNTRIES = [
  { code: "DE", name: "Deutschland", flag: "🇩🇪" },
  { code: "AT", name: "Österreich", flag: "🇦🇹" },
  { code: "CH", name: "Schweiz", flag: "🇨🇭" },
  { code: "LI", name: "Liechtenstein", flag: "🇱🇮" },
  { code: "LU", name: "Luxemburg", flag: "🇱🇺" },
  { code: "FR", name: "Frankreich", flag: "🇫🇷" },
  { code: "IT", name: "Italien", flag: "🇮🇹" },
  { code: "NL", name: "Niederlande", flag: "🇳🇱" },
  { code: "BE", name: "Belgien", flag: "🇧🇪" },
  { code: "DK", name: "Dänemark", flag: "🇩🇰" },
  { code: "PL", name: "Polen", flag: "🇵🇱" },
  { code: "CZ", name: "Tschechien", flag: "🇨🇿" },
  // --- alphabetical rest ---
  { code: "AF", name: "Afghanistan", flag: "🇦🇫" },
  { code: "AL", name: "Albanien", flag: "🇦🇱" },
  { code: "DZ", name: "Algerien", flag: "🇩🇿" },
  { code: "AD", name: "Andorra", flag: "🇦🇩" },
  { code: "AO", name: "Angola", flag: "🇦🇴" },
  { code: "AR", name: "Argentinien", flag: "🇦🇷" },
  { code: "AM", name: "Armenien", flag: "🇦🇲" },
  { code: "AU", name: "Australien", flag: "🇦🇺" },
  { code: "AZ", name: "Aserbaidschan", flag: "🇦🇿" },
  { code: "BS", name: "Bahamas", flag: "🇧🇸" },
  { code: "BH", name: "Bahrain", flag: "🇧🇭" },
  { code: "BD", name: "Bangladesch", flag: "🇧🇩" },
  { code: "BB", name: "Barbados", flag: "🇧🇧" },
  { code: "BY", name: "Belarus", flag: "🇧🇾" },
  { code: "BZ", name: "Belize", flag: "🇧🇿" },
  { code: "BJ", name: "Benin", flag: "🇧🇯" },
  { code: "BT", name: "Bhutan", flag: "🇧🇹" },
  { code: "BO", name: "Bolivien", flag: "🇧🇴" },
  { code: "BA", name: "Bosnien und Herzegowina", flag: "🇧🇦" },
  { code: "BW", name: "Botsuana", flag: "🇧🇼" },
  { code: "BR", name: "Brasilien", flag: "🇧🇷" },
  { code: "BN", name: "Brunei", flag: "🇧🇳" },
  { code: "BG", name: "Bulgarien", flag: "🇧🇬" },
  { code: "BF", name: "Burkina Faso", flag: "🇧🇫" },
  { code: "BI", name: "Burundi", flag: "🇧🇮" },
  { code: "CL", name: "Chile", flag: "🇨🇱" },
  { code: "CN", name: "China", flag: "🇨🇳" },
  { code: "CR", name: "Costa Rica", flag: "🇨🇷" },
  { code: "CI", name: "Côte d'Ivoire", flag: "🇨🇮" },
  { code: "DO", name: "Dominikanische Republik", flag: "🇩🇴" },
  { code: "DJ", name: "Dschibuti", flag: "🇩🇯" },
  { code: "DM", name: "Dominica", flag: "🇩🇲" },
  { code: "EC", name: "Ecuador", flag: "🇪🇨" },
  { code: "SV", name: "El Salvador", flag: "🇸🇻" },
  { code: "ER", name: "Eritrea", flag: "🇪🇷" },
  { code: "EE", name: "Estland", flag: "🇪🇪" },
  { code: "SZ", name: "Eswatini", flag: "🇸🇿" },
  { code: "FJ", name: "Fidschi", flag: "🇫🇯" },
  { code: "FI", name: "Finnland", flag: "🇫🇮" },
  { code: "GA", name: "Gabun", flag: "🇬🇦" },
  { code: "GM", name: "Gambia", flag: "🇬🇲" },
  { code: "GE", name: "Georgien", flag: "🇬🇪" },
  { code: "GH", name: "Ghana", flag: "🇬🇭" },
  { code: "GD", name: "Grenada", flag: "🇬🇩" },
  { code: "GR", name: "Griechenland", flag: "🇬🇷" },
  { code: "GT", name: "Guatemala", flag: "🇬🇹" },
  { code: "GN", name: "Guinea", flag: "🇬🇳" },
  { code: "GW", name: "Guinea-Bissau", flag: "🇬🇼" },
  { code: "GY", name: "Guyana", flag: "🇬🇾" },
  { code: "HT", name: "Haiti", flag: "🇭🇹" },
  { code: "HN", name: "Honduras", flag: "🇭🇳" },
  { code: "IN", name: "Indien", flag: "🇮🇳" },
  { code: "ID", name: "Indonesien", flag: "🇮🇩" },
  { code: "IQ", name: "Irak", flag: "🇮🇶" },
  { code: "IR", name: "Iran", flag: "🇮🇷" },
  { code: "IE", name: "Irland", flag: "🇮🇪" },
  { code: "IS", name: "Island", flag: "🇮🇸" },
  { code: "IL", name: "Israel", flag: "🇮🇱" },
  { code: "JM", name: "Jamaika", flag: "🇯🇲" },
  { code: "JP", name: "Japan", flag: "🇯🇵" },
  { code: "YE", name: "Jemen", flag: "🇾🇪" },
  { code: "JO", name: "Jordanien", flag: "🇯🇴" },
  { code: "KH", name: "Kambodscha", flag: "🇰🇭" },
  { code: "CM", name: "Kamerun", flag: "🇨🇲" },
  { code: "CA", name: "Kanada", flag: "🇨🇦" },
  { code: "CV", name: "Kap Verde", flag: "🇨🇻" },
  { code: "KZ", name: "Kasachstan", flag: "🇰🇿" },
  { code: "QA", name: "Katar", flag: "🇶🇦" },
  { code: "KE", name: "Kenia", flag: "🇰🇪" },
  { code: "KG", name: "Kirgisistan", flag: "🇰🇬" },
  { code: "KI", name: "Kiribati", flag: "🇰🇮" },
  { code: "CO", name: "Kolumbien", flag: "🇨🇴" },
  { code: "KM", name: "Komoren", flag: "🇰🇲" },
  { code: "CD", name: "Kongo (Dem. Rep.)", flag: "🇨🇩" },
  { code: "CG", name: "Kongo (Rep.)", flag: "🇨🇬" },
  { code: "XK", name: "Kosovo", flag: "🇽🇰" },
  { code: "HR", name: "Kroatien", flag: "🇭🇷" },
  { code: "CU", name: "Kuba", flag: "🇨🇺" },
  { code: "KW", name: "Kuwait", flag: "🇰🇼" },
  { code: "LA", name: "Laos", flag: "🇱🇦" },
  { code: "LS", name: "Lesotho", flag: "🇱🇸" },
  { code: "LV", name: "Lettland", flag: "🇱🇻" },
  { code: "LB", name: "Libanon", flag: "🇱🇧" },
  { code: "LR", name: "Liberia", flag: "🇱🇷" },
  { code: "LY", name: "Libyen", flag: "🇱🇾" },
  { code: "LT", name: "Litauen", flag: "🇱🇹" },
  { code: "MG", name: "Madagaskar", flag: "🇲🇬" },
  { code: "MW", name: "Malawi", flag: "🇲🇼" },
  { code: "MY", name: "Malaysia", flag: "🇲🇾" },
  { code: "MV", name: "Malediven", flag: "🇲🇻" },
  { code: "ML", name: "Mali", flag: "🇲🇱" },
  { code: "MT", name: "Malta", flag: "🇲🇹" },
  { code: "MA", name: "Marokko", flag: "🇲🇦" },
  { code: "MH", name: "Marshallinseln", flag: "🇲🇭" },
  { code: "MR", name: "Mauretanien", flag: "🇲🇷" },
  { code: "MU", name: "Mauritius", flag: "🇲🇺" },
  { code: "MX", name: "Mexiko", flag: "🇲🇽" },
  { code: "FM", name: "Mikronesien", flag: "🇫🇲" },
  { code: "MD", name: "Moldau", flag: "🇲🇩" },
  { code: "MC", name: "Monaco", flag: "🇲🇨" },
  { code: "MN", name: "Mongolei", flag: "🇲🇳" },
  { code: "ME", name: "Montenegro", flag: "🇲🇪" },
  { code: "MZ", name: "Mosambik", flag: "🇲🇿" },
  { code: "MM", name: "Myanmar", flag: "🇲🇲" },
  { code: "NA", name: "Namibia", flag: "🇳🇦" },
  { code: "NR", name: "Nauru", flag: "🇳🇷" },
  { code: "NP", name: "Nepal", flag: "🇳🇵" },
  { code: "NZ", name: "Neuseeland", flag: "🇳🇿" },
  { code: "NI", name: "Nicaragua", flag: "🇳🇮" },
  { code: "NE", name: "Niger", flag: "🇳🇪" },
  { code: "NG", name: "Nigeria", flag: "🇳🇬" },
  { code: "KP", name: "Nordkorea", flag: "🇰🇵" },
  { code: "MK", name: "Nordmazedonien", flag: "🇲🇰" },
  { code: "NO", name: "Norwegen", flag: "🇳🇴" },
  { code: "OM", name: "Oman", flag: "🇴🇲" },
  { code: "PK", name: "Pakistan", flag: "🇵🇰" },
  { code: "PW", name: "Palau", flag: "🇵🇼" },
  { code: "PS", name: "Palästina", flag: "🇵🇸" },
  { code: "PA", name: "Panama", flag: "🇵🇦" },
  { code: "PG", name: "Papua-Neuguinea", flag: "🇵🇬" },
  { code: "PY", name: "Paraguay", flag: "🇵🇾" },
  { code: "PE", name: "Peru", flag: "🇵🇪" },
  { code: "PH", name: "Philippinen", flag: "🇵🇭" },
  { code: "PT", name: "Portugal", flag: "🇵🇹" },
  { code: "RW", name: "Ruanda", flag: "🇷🇼" },
  { code: "RO", name: "Rumänien", flag: "🇷🇴" },
  { code: "RU", name: "Russland", flag: "🇷🇺" },
  { code: "SB", name: "Salomonen", flag: "🇸🇧" },
  { code: "ZM", name: "Sambia", flag: "🇿🇲" },
  { code: "WS", name: "Samoa", flag: "🇼🇸" },
  { code: "SM", name: "San Marino", flag: "🇸🇲" },
  { code: "ST", name: "São Tomé und Príncipe", flag: "🇸🇹" },
  { code: "SA", name: "Saudi-Arabien", flag: "🇸🇦" },
  { code: "SE", name: "Schweden", flag: "🇸🇪" },
  { code: "SN", name: "Senegal", flag: "🇸🇳" },
  { code: "RS", name: "Serbien", flag: "🇷🇸" },
  { code: "SC", name: "Seychellen", flag: "🇸🇨" },
  { code: "SL", name: "Sierra Leone", flag: "🇸🇱" },
  { code: "ZW", name: "Simbabwe", flag: "🇿🇼" },
  { code: "SG", name: "Singapur", flag: "🇸🇬" },
  { code: "SK", name: "Slowakei", flag: "🇸🇰" },
  { code: "SI", name: "Slowenien", flag: "🇸🇮" },
  { code: "SO", name: "Somalia", flag: "🇸🇴" },
  { code: "ES", name: "Spanien", flag: "🇪🇸" },
  { code: "LK", name: "Sri Lanka", flag: "🇱🇰" },
  { code: "KN", name: "St. Kitts und Nevis", flag: "🇰🇳" },
  { code: "LC", name: "St. Lucia", flag: "🇱🇨" },
  { code: "VC", name: "St. Vincent und die Grenadinen", flag: "🇻🇨" },
  { code: "ZA", name: "Südafrika", flag: "🇿🇦" },
  { code: "SD", name: "Sudan", flag: "🇸🇩" },
  { code: "SS", name: "Südsudan", flag: "🇸🇸" },
  { code: "KR", name: "Südkorea", flag: "🇰🇷" },
  { code: "SR", name: "Suriname", flag: "🇸🇷" },
  { code: "SY", name: "Syrien", flag: "🇸🇾" },
  { code: "TJ", name: "Tadschikistan", flag: "🇹🇯" },
  { code: "TW", name: "Taiwan", flag: "🇹🇼" },
  { code: "TZ", name: "Tansania", flag: "🇹🇿" },
  { code: "TH", name: "Thailand", flag: "🇹🇭" },
  { code: "TL", name: "Timor-Leste", flag: "🇹🇱" },
  { code: "TG", name: "Togo", flag: "🇹🇬" },
  { code: "TO", name: "Tonga", flag: "🇹🇴" },
  { code: "TT", name: "Trinidad und Tobago", flag: "🇹🇹" },
  { code: "TD", name: "Tschad", flag: "🇹🇩" },
  { code: "TN", name: "Tunesien", flag: "🇹🇳" },
  { code: "TR", name: "Türkei", flag: "🇹🇷" },
  { code: "TM", name: "Turkmenistan", flag: "🇹🇲" },
  { code: "TV", name: "Tuvalu", flag: "🇹🇻" },
  { code: "UG", name: "Uganda", flag: "🇺🇬" },
  { code: "UA", name: "Ukraine", flag: "🇺🇦" },
  { code: "HU", name: "Ungarn", flag: "🇭🇺" },
  { code: "UY", name: "Uruguay", flag: "🇺🇾" },
  { code: "UZ", name: "Usbekistan", flag: "🇺🇿" },
  { code: "VU", name: "Vanuatu", flag: "🇻🇺" },
  { code: "VA", name: "Vatikanstadt", flag: "🇻🇦" },
  { code: "VE", name: "Venezuela", flag: "🇻🇪" },
  { code: "AE", name: "Vereinigte Arabische Emirate", flag: "🇦🇪" },
  { code: "US", name: "Vereinigte Staaten", flag: "🇺🇸" },
  { code: "GB", name: "Vereinigtes Königreich", flag: "🇬🇧" },
  { code: "VN", name: "Vietnam", flag: "🇻🇳" },
  { code: "CF", name: "Zentralafrikanische Republik", flag: "🇨🇫" },
  { code: "CY", name: "Zypern", flag: "🇨🇾" },
  { code: "EG", name: "Ägypten", flag: "🇪🇬" },
  { code: "GQ", name: "Äquatorialguinea", flag: "🇬🇶" },
  { code: "ET", name: "Äthiopien", flag: "🇪🇹" },
];
